var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFrance = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "18-France"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.518066 7C0.518066 8.59783 1.14029 10.1 2.27012 11.2299C3.39995 12.3597 4.90214 12.9819 6.49997 12.9819C8.0978 12.9819 9.59999 12.3597 10.7298 11.2299C11.8597 10.1 12.4819 8.59783 12.4819 7C12.4819 5.40217 11.8597 3.89998 10.7298 2.77015C9.59999 1.64032 8.0978 1.0181 6.49997 1.0181C4.90214 1.0181 3.39995 1.64032 2.27012 2.77015C1.14029 3.89998 0.518066 5.40217 0.518066 7Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39674 1.39697V12.6034C3.6076 12.3078 2.88397 11.8437 2.27027 11.23C1.14039 10.1001 0.518066 8.59801 0.518066 7.00018C0.518066 5.40234 1.14039 3.90023 2.27027 2.77035C2.88397 2.15666 3.6076 1.69252 4.39674 1.39697Z",
    fill: "#0055A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60327 1.39697V12.6034C9.39241 12.3078 10.116 11.8437 10.7297 11.23C11.8596 10.1001 12.4819 8.59801 12.4819 7.00018C12.4819 5.40234 11.8596 3.90023 10.7297 2.77035C10.116 2.15666 9.39241 1.69252 8.60327 1.39697Z",
    fill: "#EF4135"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFrance);
export default ForwardRef;